/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import type { IHeaderParams } from 'ag-grid-community'
import { Tooltip } from 'antd'
import { MODAL_TOKENS } from 'src/styles/modalTokens'

export interface AttendanceTooltipHeaderParams {
  tooltip: string
}

/**
 * A plain (non-sortable) attendance column header with an explanation on
 * hover. Uses AG Grid's header text class so it matches every other header.
 */
const AttendanceTooltipHeader = ({
  displayName,
  tooltip,
}: IHeaderParams & AttendanceTooltipHeaderParams) => (
  <Tooltip title={tooltip} zIndex={MODAL_TOKENS.Z_INDEX_TOOLTIP}>
    <span css={labelStyle} aria-description={tooltip}>
      <span className='ag-header-cell-text'>{displayName}</span>
    </span>
  </Tooltip>
)

export default AttendanceTooltipHeader

const labelStyle = css`
  display: inline-flex;
  align-items: center;
`
